import React from 'react';
import { formatMinutesToDuration } from '../../utils/myWorkFormatters';

/**
 * WeeklyCapacityCards Component
 * Column 3 of the Weekly Work Overview.
 * Displays Total Approx. Capacity and Remaining Capacity based on configured schedule.
 * Note: Strictly omits utilization %, performance scores, and ratings per specification.
 */
export default function WeeklyCapacityCards({
    totalCapacityMinutes = 2400, // 40h standard week
    remainingCapacityMinutes = 2400, // available capacity starts at total
}) {
    const formattedTotal = formatMinutesToDuration(totalCapacityMinutes);
    const formattedRemaining = formatMinutesToDuration(remainingCapacityMinutes);

    return (
        <div className="flex flex-col lg:pl-8 pt-6 lg:pt-0">
            <div className="mb-5">
                <h3 className="text-base font-bold text-slate-900 dark:text-white font-headline tracking-tight">
                    Weekly Capacity
                </h3>
                <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                    Your available capacity for the week.
                </p>
            </div>

            <div className="space-y-3.5 my-auto">
                {/* Total Approx. Capacity Card */}
                <div className="bg-[#F3F8FD] dark:bg-blue-950/20 border border-blue-100/70 dark:border-blue-900/40 rounded-xl p-4 flex items-center gap-4 transition-all">
                    <div className="w-12 h-12 rounded-xl bg-blue-100/70 dark:bg-blue-900/40 flex items-center justify-center flex-shrink-0 text-blue-600 dark:text-blue-400">
                        <span className="material-symbols-outlined text-2xl">calendar_month</span>
                    </div>
                    <div>
                        <div className="text-xs font-semibold text-slate-700 dark:text-slate-300">
                            Total Approx. Capacity
                        </div>
                        <div className="text-2xl font-bold text-slate-900 dark:text-white font-headline mt-0.5">
                            {formattedTotal}
                        </div>
                    </div>
                </div>

                {/* Remaining Capacity Card */}
                <div className="bg-[#F2F9F5] dark:bg-emerald-950/20 border border-emerald-100/70 dark:border-emerald-900/40 rounded-xl p-4 flex items-center gap-4 transition-all">
                    <div className="w-12 h-12 rounded-xl bg-emerald-100/70 dark:bg-emerald-900/40 flex items-center justify-center flex-shrink-0 text-emerald-600 dark:text-emerald-400">
                        <span className="material-symbols-outlined text-2xl">schedule</span>
                    </div>
                    <div>
                        <div className="text-xs font-semibold text-slate-700 dark:text-slate-300">
                            Remaining Capacity
                        </div>
                        <div className="text-2xl font-bold text-slate-900 dark:text-white font-headline mt-0.5">
                            {formattedRemaining}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
